import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const initState = {
  vendingCount: {},
  isLoadingVendingCount: false,
  vendingList: {
    data: [],
    offset: -1,
    limit: 10,
    length: 0,
    total: 0,
    isLoading: false,
    hasMore: false,
  },
  isLoadingVending: false,
  isRefreshingVendingList: false,
  isLoadingVendingUpdate: false,  

  isLoadingVendingLocation: false,
  vendingLocationList: [],

  vendingDetail: null,
  isLoadingVendingDetail: false,

  isCreateVendingSuccess: false,
  isCreateVendingFailed: false,
  isProcessCreateVending: false,

  isUpdateVendingSuccess: false,
  isUpdateVendingFailed: false,
  isProcessUpdateVending: false,
  
  isResetPwdSuccess: false,
  isResetPwdFailed: false,
  isProcessResetPwd: false,

  isRemoveVendingSuccess: false,
  isProcessRemoveVending: false,
  
  isRebootVendingSuccess: false,
  isRebootVendingFailed: false,
  isProcessRebootVending: false,  
  rebootVendingConfirm: null,

  isStopVendingSuccess: false,
  isStopVendingFailed: false,
  isProcessStopVending: false,

  isStartVendingSuccess: false,
  isStartVendingFailed: false,
  isProcessStartVending: false,

  isVendingTestConnectionSuccess: false,
  isVendingTestConnectionFailed: false,
  isProcessVendingTestConnection: false,

  isVendingSetPlacementSuccess: false,
  isVendingSetPlacementFailed: false,
  isProcessVendingSetPlacement: false,
  
};

export default function VendingReducer(state = initState, action) {

  switch (action.type) {

    
    case actionTypes.LOAD_VENDING_COUNT:{

      return {
        ...state,
        vendingCount: {},
        isLoadingVendingCount: true,
      };
    }

    case actionTypes.LOAD_VENDING_COUNT_SUCCESS: {

      return {
        ...state,
        vendingCount: action.data,
        isLoadingVendingCount: false,
      };
    }

    case actionTypes.LOAD_VENDING_COUNT_FAIL:{
      return {
        ...state,
        isLoadingVendingCount: false,
      };
    }


    case actionTypes.LOAD_VENDING_LOCATION_LIST:{
            
      return {
        ...state,
        isLoadingVendingLocation: true,
        vendingLocationList: [],
      };
    }

    case actionTypes.LOAD_VENDING_LOCATION_LIST_SUCCESS: {
     
      return {
        ...state,
        isLoadingVendingLocation: false,
        vendingLocationList: action.data
      };
    }

    case actionTypes.LOAD_VENDING_LOCATION_LIST_FAIL:{
      return {
        ...state,
        isLoadingVendingLocation: false,
      };
    }


    case actionTypes.LOAD_VENDING_LIST:{
      let vendingList = cloneDeep(state.vendingList);
  
      vendingList.isLoading = true;

      if (action.data.offset === 0) {
        vendingList.data = [];
      }
      
      return {
        ...state,
        isLoadingVending: true,
        vendingList,
        isRefreshingVendingList: (action.data.offset > 0) ? true : false
      };
    }

    case actionTypes.LOAD_VENDING_LIST_SUCCESS: {
      let vendingList = {};
      
      if (action.data.limit === undefined) {
        vendingList = cloneDeep(state.vendingList);
        vendingList.data = action.data.data;
      } else {
        vendingList.offset = -1;

        // First time load / Refresh
        if (action.data.offset === 0) {
          vendingList.data = action.data.data;
          vendingList.length = action.data.total_result;
        } else {
          if (action.data.total_result === 0) {
            vendingList.data = [...state.vendingList.data];
            vendingList.offset = action.data.offset;
          } else {
            let temp = [...state.vendingList.data];
            let old_key = Object.keys(temp);
            Object.keys(action.data.data).forEach((val) => {
              if (old_key.includes(val)) {
                temp.push(action.data.data[val]);
              }
            });

            vendingList.data = temp;
            vendingList.length = state.vendingList.length + action.data.total_result;
          }
        }
        if (action.data.total_result < action.data.limit) {
          vendingList.offset = vendingList.length;
        }
      }
  
      vendingList.isLoading = false;
      vendingList.total = action.data.total;
      vendingList.hasMore = false;
      
      if(vendingList.length < vendingList.total)
      {
        vendingList.hasMore = true;
      }

      return {
        ...state,
        isLoadingVending: false,
        isLoadingVendingUpdate: false,
        vendingList
      };
    }

    case actionTypes.LOAD_VENDING_LIST_FAIL:{
      let vendingList = cloneDeep(state.vendingList);
      vendingList.isLoading = false;

      return {
        ...state,
        vendingList,
        isLoadingVending: false,
      };
    }



    case actionTypes.LOAD_VENDING_DETAIL: {

      return {
        ...state,
        vendingDetail: (action.data && action.data.reload) ? {} : cloneDeep(state.vendingDetail),
        vendingDetail_backup: cloneDeep(state.vendingDetail),
        isLoadingVendingDetail: true,
      };
    }

    case actionTypes.LOAD_VENDING_DETAIL_SUCCESS: {
      return {
        ...state,
        vendingDetail: action.data,
        isLoadingVendingDetail: false,
      };
    }

    case actionTypes.LOAD_VENDING_DETAIL_FAIL: {
      return {
        ...state,
        isLoadingVendingDetail: false,
      };
    }

    case actionTypes.LOAD_VENDING_DETAIL_DUPLICATE: {
      return {
        ...state,
        vendingDetail: state.vendingDetail_backup,
        isLoadingVendingDetail: false,
      };
    }

    

    case actionTypes.CREATE_VENDING: {
      return {
        ...state,
        isCreateVendingSuccess: false,
        isCreateVendingFailed: false,
        isProcessCreateVending: true,
      };
    }

    case actionTypes.CREATE_VENDING_SUCCESS: {
      return {
        ...state,
        isCreateVendingSuccess: true,
        isProcessCreateVending: false,
      };
    }

    case actionTypes.CREATE_VENDING_FAIL: {
      return {
        ...state,
        isCreateVendingFailed: true,
        isProcessCreateVending: false,
      };
    }


    case actionTypes.UPDATE_VENDING: {
      return {
        ...state,
        isUpdateVendingSuccess: false,
        isUpdateVendingFailed: false,
        isProcessUpdateVending: true,
      };
    }

    case actionTypes.UPDATE_VENDING_SUCCESS: {
      return {
        ...state,
        isUpdateVendingSuccess: true,
        isProcessUpdateVending: false,
      };
    }

    case actionTypes.UPDATE_VENDING_FAIL: {
      return {
        ...state,
        isUpdateVendingFailed: true,
        isProcessUpdateVending: false,
      };
    }



    case actionTypes.RESET_PWD_VENDING: {
      return {
        ...state,
        isResetPwdSuccess: false,
        isResetPwdFailed: false,
        isProcessResetPwd: true,
      };
    }

    case actionTypes.RESET_PWD_VENDING_SUCCESS: {
      return {
        ...state,
        isResetPwdSuccess: true,
        isProcessResetPwd: false,
      };
    }

    case actionTypes.RESET_PWD_VENDING_FAIL: {
      return {
        ...state,
        isResetPwdFailed: true,
        isProcessResetPwd: false,
      };
    }
    
    case actionTypes.REMOVE_VENDING: {
      return {
        ...state,
        isRemoveVendingSuccess: false,
        isProcessRemoveVending: true,
      };
    }

    case actionTypes.REMOVE_VENDING_SUCCESS: {
      return {
        ...state,
        isRemoveVendingSuccess: true,
        isProcessRemoveVending: false,
      };
    }

    case actionTypes.REMOVE_VENDING_FAIL: {
      return {
        ...state,
        isRemoveVendingSuccess: false,
        isProcessRemoveVending: false,
      };
    }


    case actionTypes.REBOOT_VENDING: {
      return {
        ...state,
        isRebootVendingSuccess: false,
        isRebootVendingFailed: false,
        isProcessRebootVending: true,
        rebootVendingConfirm: null,
      };
    }

    case actionTypes.REBOOT_VENDING_SUCCESS: {
      return {
        ...state,
        isRebootVendingSuccess: (action.data) ? false : true,
        isProcessRebootVending: false,
        rebootVendingConfirm: (action.data) ? action.data : null
      };
    }

    case actionTypes.REBOOT_VENDING_FAIL: {
      return {
        ...state,
        isRebootVendingFailed: true,
        isProcessRebootVending: false,
      };
    }


    case actionTypes.STOP_VENDING: {
      return {
        ...state,
        isStopVendingSuccess: false,
        isStopVendingFailed: false,
        isProcessStopVending: true,
      };
    }

    case actionTypes.STOP_VENDING_SUCCESS: {
      return {
        ...state,
        isStopVendingSuccess: true,
        isProcessStopVending: false,
      };
    }

    case actionTypes.STOP_VENDING_FAIL: {
      return {
        ...state,
        isStopVendingFailed: true,
        isProcessStopVending: false,
      };
    }


    case actionTypes.START_VENDING: {
      return {
        ...state,
        isStartVendingSuccess: false,
        isStartVendingFailed: false,
        isProcessStartVending: true,
      };
    }

    case actionTypes.START_VENDING_SUCCESS: {
      return {
        ...state,
        isStartVendingSuccess: true,
        isProcessStartVending: false,
      };
    }

    case actionTypes.START_VENDING_FAIL: {
      return {
        ...state,
        isStartVendingFailed: true,
        isProcessStartVending: false,
      };
    }


    case actionTypes.VENDING_TEST_CONNECTION: {
      return {
        ...state,
        isVendingTestConnectionSuccess: false,
        isVendingTestConnectionFailed: false,
        isProcessVendingTestConnection: true,
      };
    }

    case actionTypes.VENDING_TEST_CONNECTION_SUCCESS: {
      return {
        ...state,
        isVendingTestConnectionSuccess: true,
        isProcessVendingTestConnection: false,
      };
    }

    case actionTypes.VENDING_TEST_CONNECTION_FAIL: {
      return {
        ...state,
        isVendingTestConnectionFailed: true,
        isProcessVendingTestConnection: false,
      };
    }


    case actionTypes.VENDING_SET_PLACEMENT: {
      return {
        ...state,
        isVendingSetPlacementSuccess: false,
        isVendingSetPlacementFailed: false,
        isProcessVendingSetPlacement: true,
      };
    }

    case actionTypes.VENDING_SET_PLACEMENT_SUCCESS: {
      return {
        ...state,
        isVendingSetPlacementSuccess: true,
        isProcessVendingSetPlacement: false,
      };
    }

    case actionTypes.VENDING_SET_PLACEMENT_FAIL: {
      return {
        ...state,
        isVendingSetPlacementFailed: true,
        isProcessVendingSetPlacement: false,
      };
    }

    default:
      return state;
  }
}
